import { render, staticRenderFns } from "./SupplierEmail.vue?vue&type=template&id=43f66ada&"
import script from "./SupplierEmail.vue?vue&type=script&lang=ts&"
export * from "./SupplierEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports